import { useContext } from "react";
import classNames from "classnames";
import QRCode from "react-qr-code";
import { IconButton, Icon } from "@livingmap/hippo";

import useControlSizeObserver from "hooks/useControlSizeObserver";

import { scaleValue } from "../../utils";

import { UIContext } from "../../contexts/UIContext";
import { MapContext } from "../Map/Map";

import styles from "./SheetWrapper.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  dataQA: string;
  qrCodeLink: string;
  className?: string;
  showQRCode?: boolean;
  children: React.ReactNode;
  onClose?: () => void;
  showNearestLabel?: boolean;
}

const SheetWrapper: React.FC<Props> = ({
  dataQA,
  qrCodeLink,
  className,
  showQRCode,
  children,
  onClose,
  showNearestLabel,
}) => {
  const { controlTheme } = useContext(MapContext);
  const { screenOrientation } = useContext(UIContext);
  const { t } = useTranslation();

  const controlSize = useControlSizeObserver();

  return (
    <div
      data-qa={dataQA}
      className={classNames(styles.container, styles[controlTheme], className, {
        [styles.landscape]: screenOrientation === "landscape",
      })}
    >
      <div
        className={classNames(styles.qrCodeContainer, {
          [styles.hide]: !showQRCode,
        })}
      >
        <div className={styles.qrCodeContent}>
          <Icon dataQA="qr-code-icon" name="send_to_mobile" size={18} />
          <p>{t("sheet_wrapper.qr_code_text")}</p>
          <div className={styles.qrCode}>
            <QRCode value={qrCodeLink} size={scaleValue(92, controlSize)} />
          </div>
        </div>
      </div>
      <div className={styles.contentContainer}>
        {children}
        {onClose && (
          <IconButton
            dataQA="poi-close-icon"
            iconSize={24}
            size="large"
            type="primary"
            icon="close"
            className={styles.closeBtn}
            onClick={onClose}
          />
        )}
        {!onClose && showNearestLabel && (
          <div className={styles.label}>
            {t("sheet_wrapper.nearest_label_text")}
          </div>
        )}
      </div>
    </div>
  );
};

export default SheetWrapper;
